import actionCreatorFactory from 'typescript-fsa';

import { Permissions } from '../../../interfaces/permission';

export const actionCreator = actionCreatorFactory();
export const permissionActions = {
  getPermissions: actionCreator.async<void, Permissions, Error>('GET_PERMISSIONS')
};
